module.exports = __webpack_public_path__ + "img/list2.4203a821.png";